import { stringify as qs_stringify } from "qs";

export const PATH_STORES = `/stores`;

export function fetchStores(usingPos) {
  return this.http.get(PATH_STORES, {
    params: {
      usingPos,
    },
  });
}

export function fetchStoreSalesAmount(storeCode, salesDate) {
  return this.http.get(`${PATH_STORES}/${storeCode}/sales-amount`, {
    params: {
      salesDate,
    },
  });
}

export function fetchStoreProductCategory(storeCode, parentCategoryCode) {
  return this.http.get(`${PATH_STORES}/${storeCode}/product-categories`, {
    params: {
      parentCode: parentCategoryCode,
    },
  });
}

export function fetchStoreProducts(storeCode, categoryCode, salesDate) {
  return this.http.get(`${PATH_STORES}/${storeCode}/products`, {
    params: {
      categoryCode,
      salesDate,
    },
  });
}

export function fetchPosTables(storeCode, salesDate) {
  return this.http.get(`${PATH_STORES}/${storeCode}/pos-tables`, {
    params: {
      salesDate,
    },
  });
}

export function fetchSlips(storeCode, salesDate, gcDiv, filters, orders,visitorName,grpName) {
  return this.http.get(`${PATH_STORES}/${storeCode}/slips`, {
    paramsSerializer(params) {
      return qs_stringify(params, { arrayFormat: "indices", allowDots: true });
    },
    params: {
      salesDate,
      gcDiv,
      filters,
      orders,
      visitorName,
      grpName
    },
  });
}

export function fetchStorePosMemo(args) {
  return this.http.get(`${PATH_STORES}/${args.storeCode}/pos-memo`, {
    params: {
      bsnDate: args.bsnDate
    }
  });
}

export function fetchStoreCoupon(args) {
  return this.http.get(`${PATH_STORES}/coupon`, {
    params: {
      storeCode: args.storeCode,
      chkinId: args.chkinId,
    },
  });
}

export function storeCheckout(storeCode, salesDate, visitorId, salesId) {
  return this.http.post(`${PATH_STORES}/${storeCode}/checkout`, {
    salesDate,
    visitorId,
    salesId,
  });
}

export function registerStoreProducts(storeCode, products) {
  return this.http.post(`${PATH_STORES}/${storeCode}/products`, products);
}

export function removeStoreProducts(storeCode, products) {
  return this.http.delete(`${PATH_STORES}/${storeCode}/products`, {
    data: products,
  });
}

export function productSortNoResetting(storeCode, data) {
  return this.http.put(`${PATH_STORES}/${storeCode}/products-sort-no-resetting`, data);
}

export function fetchOrderMonitorPrt(args) {
  return this.http.get(`${PATH_STORES}/${args.storeCode}/order-monitor-prt`, {
    isBackground: args.isBackground,
    params: {
      salesDate: args.salesDate,
      isPrtCheck : args.isPrtCheck,
    },
  });
}

export function putOrderMonitorPrt(args) {
  return this.http.put(`${PATH_STORES}/order-monitor-prt`, args);
}

// 자동출력 전용: 미출력 행을 서버에서 원자적으로 선점한 뒤 그 행들만 반환.
// 다중 PC 동시 폴링 시 동일 주문 중복 출력 방지 (FOR UPDATE SKIP LOCKED).
// ackMode=true: 선점→확정 2단계 방식 opt-in. 서버는 선점(CLAIM_DT)만 마킹하고,
// 출력 성공 후 확정 PUT(putOrderMonitorPrt printFlag=true)이 와야 PRINT_FLAG 확정.
// 유효시간 내 확정이 없으면 재노출된다 (구버전 프론트는 ackMode 미전송 → 서버가 기존 즉시확정 방식으로 처리).
export function claimOrderMonitorPrt(args) {
  return this.http.post(`${PATH_STORES}/${args.storeCode}/order-monitor-prt/claim`, null, {
    isBackground: args.isBackground,
    params: {
      salesDate: args.salesDate,
      ackMode: true,
      pcUseCode: args.pcUseCode,
    },
  });
}